<template>
  <b-alert show variant="warning" class="py-2">
    <b-row align-h="center">
      <b-col cols="10">
        <span class="text-grey" v-html="$t('components.subscription_bar.message', {days: trialDay < 0 ? 0 : trialDay})">
      </span>
        <b-btn variant="success" size="sm" @click="upgrade"
               class="mx-2 text-white upgrade-plan">
          {{ $t('components.subscription_bar.upgrade') }}
        </b-btn>
      </b-col>
    </b-row>
  </b-alert>
</template>

<script>
import moment from "moment";

export default {
  name: "TrialExpired",
  computed: {
    trialDay() {
      if (this.$auth.user()?.subscription?.trial_ends_at) {
        // this.$auth.user().subscription.trial_ends_at
        return moment(+new Date()).diff(moment({hours: 0}), 'days') - 1
      }
      return 0
    }
  },
  methods: {
    upgrade() {
      this.$router.push({name:'settings', query:  {tab: 'subscription', tm: + new Date()}})
    }
  }
}
</script>

<style scoped>
.upgrade-plan:hover {
  color: #d5d5d5 !important;
}
</style>